import i18n from '../../../i18n';

export const installedСonsumablesReportFields = [
    "partType",
    "partModelCode",
    "partSerialNumber",
    "level",
    "modelCode",
    "hostname",
    "ip",
    "location",
    "serialNumber",
    "inventoryNumber",
    "deviceType",
    "colorType",
    "paperFormat",
    "refreshDate"
];

export const installedСonsumablesReportConfig = {
    code : 'INSTALLED_CONSUMABLES',
    gridStateKey: 'gridReportInstalledРЎonsumables',
    filter: {
        getter: 'installedРЎonsumablesFilter',
        mutation: 'setInstalledРЎonsumablesFilter'
    },
    columns: [{
        id: 1,
        dataField : 'partType',
        caption : i18n.t('report.titleReports.installingConsumables.partType'),
        dataType : 'string',
        sortOrder: 10
    }, {
        id: 2,
        dataField : 'partModelCode',
        caption : i18n.t('report.titleReports.installingConsumables.partModelCode'),
        dataType : 'string',
        sortOrder: 20
    }, {
        id: 3,
        dataField : 'partSerialNumber',
        caption : i18n.t('report.titleReports.installingConsumables.partSerialNumber'),
        dataType : 'string',
        sortOrder: 30
    }, {
        id: 4,
        dataField : 'level',
        caption : i18n.t('report.titleReports.installingConsumables.level'),
        dataType : 'number',
        sortOrder: 40
    }, {
        id: 5,
        dataField : 'modelCode',
        caption : i18n.t('report.titleReports.installingConsumables.modelCode'),
        dataType : 'string',
        sortOrder: 50
      }, {
        id: 6,
        dataField : 'hostname',
        caption : i18n.t('report.titleReports.installingConsumables.hostname'),
        dataType : 'string',
        sortOrder: 60
      }, {
        id: 7,
        dataField : 'ip',
        caption : i18n.t('report.titleReports.installingConsumables.ip'),
        dataType : 'string',
        sortOrder: 70
      }, {
        id: 8,
        dataField : 'location',
        caption : i18n.t('report.titleReports.installingConsumables.location'),
        dataType : 'string',
        sortOrder: 80
      }, {
        id: 9,
        dataField : 'serialNumber',
        caption : i18n.t('report.titleReports.installingConsumables.serialNumber'),
        dataType : 'string',
        sortOrder: 90
      }, {
        id: 10,
        dataField : 'inventoryNumber',
        caption : i18n.t('report.titleReports.installingConsumables.inventoryNumber'),
        dataType : 'string',
        sortOrder: 100
      }, {
        id: 11,
        dataField : 'deviceType',
        caption : i18n.t('report.titleReports.installingConsumables.deviceType'),
        dataType : 'string',
        sortOrder: 110,
      }, {
        id: 12,
        dataField : 'colorType',
        caption : i18n.t('report.titleReports.installingConsumables.colorType'),
        dataType : 'string',
        sortOrder: 120
      }, {
        id: 13,
        dataField : 'paperFormat',
        caption : i18n.t('report.titleReports.installingConsumables.paperFormat'),
        dataType : 'string',
        sortOrder: 130
      }, {
        id: 14,
        dataField : 'refreshDate',
        caption : i18n.t('report.titleReports.installingConsumables.refreshDate'),
        dataType : 'date',
        format : 'dd.MM.yyyy HH:mm:ss',
        sortOrder: 140
      }]
}
